module.exports = __webpack_public_path__ + "img/5.8e9d0c1c.png";